import { Container, Col, Row } from "reactstrap";
import { BreadcrumbItem } from "reactstrap";
import * as KeyQL from "queries/domain-key";
import * as Notify from "@repoflow/form-schema/notify";
import { CancellableContent } from "@repoflow/components/content-cancel";

import {
  Mutation,
  Button,
  useSectionContext,
} from "@repoflow/components/section";

export const Sidebar = () => null;

export const Indice = ({ match: { params } }) => (
  <>
    <BreadcrumbItem>Remove</BreadcrumbItem>
  </>
);

export const Content = ({ history, match: { params } }) => {
  const {
    parent: { base },
  } = useSectionContext();

  return (
    <CancellableContent>
      <Row>
        <Col>
          Removing the API key <b>{params.keyId}</b>? This action will be
          permanent and can't be undone
        </Col>
      </Row>
      <Mutation
        mutation={KeyQL.remove}
        update={KeyQL.update(params)}
        onMutate={({ handler }) => {
          handler({
            variables: params,
          });
        }}
        onCompleted={() => {
          history.replace(base);
        }}
        onError={(error) => {
          Notify.error(error.toString());
        }}
      >
        {MutationHandler}
      </Mutation>
    </CancellableContent>
  );
};

const MutationHandler = ({ mutate }) => {
  return (
    <Container className="mt-4">
      <Row>
        <Col>
          <Button
            onClick={() => {
              mutate();
            }}
          >
            Remove
          </Button>
        </Col>
      </Row>
    </Container>
  );
};
